import { IProfilingCode } from 'legacy/lut/classes/models/profiling/codes'

import { IToolAccessConditions } from 'clickNgo/entities/contactFlag'

import { HEADQUARTERS_ONLY_FLAGS } from '../configs'

interface IApplyToolAccessConditionsParams {
  isHQ: boolean
  toolAccessConditions: IToolAccessConditions[]
}

export const applyToolAccessConditions = ({
  isHQ,
  toolAccessConditions,
}: IApplyToolAccessConditionsParams) => {
  return (profilingCodeList: IProfilingCode[]) => {
    return profilingCodeList.map<IProfilingCode>((profilingCode) => {
      const toolAccessCondition = toolAccessConditions.find((condition) => {
        return condition.flag === profilingCode.code && !condition.conditionFulfilled
      })

      if (!isHQ && HEADQUARTERS_ONLY_FLAGS[profilingCode.code]) {
        return {
          ...profilingCode,
          comment: HEADQUARTERS_ONLY_FLAGS[profilingCode.code].defaultMessage,
        }
      }

      if (toolAccessCondition?.comment) {
        return {
          ...profilingCode,
          comment: toolAccessCondition.comment,
        }
      }

      return profilingCode
    })
  }
}
